<template>
  <div class="page">
    <summary-header />
    <v-container class="contents">
      <v-row class="">
        <v-col class="">
          <v-card tile flat height="340">
            <div class="d-flex">
              <div class="section-title">
                + LIFE Cycle
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <table class="tbl mt-3">
              <thead>
                <tr style="">
                  <th class="title-cell text-left">
                    <div style=" line- border-bottom: 2px solid grey; padding-left: 10px !important; font-size: 12px; width: 90%">연도</div>
                  </th>
                  <th class="text-center" v-for="n in cellLength" :key="n">
                    <div style=" line- border-bottom: 1px solid grey; font-size: 12px">
                      {{ `'${(currentYear - 1 + n).toString().substr(2, 2)}` }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="exit-row">
                  <td class="text-center title-cell">
                    <div class="col-header"><span class="ml-1">Exit</span></div>
                  </td>
                  <td :class="['text-center', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <div :class="[n === 1 ? 'start-row' : '', n === cellLength ? '' : '']">{{ exit[0][n - 1] }}</div>
                  </td>
                </tr>
                <tr style="">
                  <td class="text-center title-cell main">
                    <div class="bottom-border" style="width: 85%">(예상)月생활비</div>
                  </td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '', 'bottom-border']" v-for="n in cellLength" :key="n">{{ exit[1][n - 1] }}</td>
                </tr>
                <tr class="age-row">
                  <td class="text-left title-cell main" rowspan="2">본인</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '', 'main']" v-for="n in cellLength" :key="n">{{ exit[2][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <img v-if="exit[3][n - 1]" height="25px" :src="getImg(exit[3][n - 1])" />
                  </td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">국민연금</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[4][n - 1] }}</td>
                </tr>
                <tr>
                  <td class="text-left title-cell">퇴직연금</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[5][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">
                    <div class="bottom-border" style="width: 85%">개인연금</div>
                  </td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '', 'bottom-border']" v-for="n in cellLength" :key="n">{{ exit[6][n - 1] }}</td>
                </tr>
                <tr class="age-row">
                  <td class="text-left title-cell" rowspan="2">배우자</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[7][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">
                    <img v-if="exit[8][n - 1]" height="20px" :src="getImg(exit[8][n - 1])" />
                  </td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">국민연금</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[9][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">퇴직연금</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[10][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell"><div class="bottom-border" style="width: 85%">개인연금</div></td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '', 'bottom-border']" v-for="n in cellLength" :key="n">{{ exit[11][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">주택연금</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[12][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">근로소득</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[13][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">기타</td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '']" v-for="n in cellLength" :key="n">{{ exit[14][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">
                    <div class="bottom-border" style="width: 85%">합</div>
                  </td>
                  <td :class="['text-right', exit[0][n - 1] ? 'event' : '', 'bottom-border']" v-for="n in cellLength" :key="n">{{ exit[15][n - 1] }}</td>
                </tr>
                <tr style="">
                  <td class="text-left title-cell">
                    <div class="" style="position: initial">
                      현금흐름
                      <br />
                      (소득-생활비)
                    </div>
                  </td>
                  <td :class="['text-right', '', 'font-weight-black', exit[16][n - 1] < 0 ? 'minus' : '']" v-for="n in cellLength" :key="n">
                    {{ Math.round(exit[16][n - 1]) }}
                  </td>
                </tr>
                <tr class="bottom-border"></tr>
              </tbody>
            </table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title">+ Cash Flow</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-chart class="chart" :options="opt" autoresize ref="chart"></v-chart>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">은퇴 크레바스</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="4">
                  <p class="question mb-0"><span class="subtitle-2">은퇴 크레바스 구간은?</span></p>
                  <p class="text-h6 mb-0 ans">{{ crevasseAge }}</p>
                </v-col>
                <v-col cols="4">
                  <p class="question mb-0">
                    <span class="subtitle-2">크레바스 구간 조정대안은?</span>
                  </p>
                  <p class="text-h6 mb-0 ans">{{ (this.finance['재무-음수구간대안'] || {}).value || '' }}</p>
                </v-col>
                <v-col cols="4">
                  <p class="question mb-0">
                    <span class="subtitle-2">퇴직 후 기대소득은?</span>
                  </p>
                  <p class="text-h6 mb-0 ans">
                    {{ ((this.finance['재무-기대근로소득'] || {}).value || [])[0].value || 0 }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- <v-row dense>
        <v-col>
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                은퇴크레바스
                <span class="text-caption" style="margin: 0 -3px">(crevasse)</span>
                조정대안's
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3">
              <v-row>
                <v-col cols="4">
                  <p class="question mb-0"><span class="subtitle-2">국민연금</span></p>
                  <p class="mb-0 ans subtitle-1 font-weight-bold">
                    &dot; 조기연금, 연기연금 선택하기
                    <br />
                    &dot; 배우자 최소연금 가입
                    <br />
                    &dot; 추가납입
                  </p>
                </v-col>
                <v-col cols="4">
                  <p class="question mb-0">
                    <span class="subtitle-2">개인/퇴직연금</span>
                  </p>
                  <p class="mb-0 ans subtitle-1 font-weight-bold">
                    &dot; 연금 수령방법 조정
                    <br />
                    <span class="pl-5" style="font-size: 0.8rem">(종신형 &rightarrow;기간확정)</span>
                    <br />
                    &dot; 추가납입
                  </p>
                </v-col>
                <v-col cols="4">
                  <p class="question mb-0">
                    <span class="subtitle-2">주택연금</span>
                  </p>
                  <p class="mb-0 ans subtitle-1 font-weight-bold">
                    공시가 5억 기준 월 지급 수령액 에시
                    <br />
                    : 70세 신청 시, 매월 000만
                    <br />
                    : 75세 신청 시, 매월 000만
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
      <v-row style="">
        <v-col cols="8">
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                PLAN 1
                <span class="text-caption">가족 이벤트 목적자금</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item class="px-0" style="min-height: 20px; border-bottom: 1px solid lightGrey">
                  <v-list-item-content style="max-width: 40px"></v-list-item-content>
                  <v-list-item-content><v-list-item-title class="text-center">가족이벤트</v-list-item-title></v-list-item-content>
                  <v-list-item-content><v-list-item-title class="text-right">필요자금</v-list-item-title></v-list-item-content>
                  <v-list-item-content><v-list-item-title class="text-right">준비시기</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-for="(m, i) in getFinanceGoalMoney.filter((m) => m.money > 0).slice(0, 3)" :key="m.title" style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content style="max-width: 40px">
                    <v-list-item-title class="text-center">{{ `${i + 1}순위` }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="text-center">
                      <span class="font-weight-bold secondary--text">{{ m.title }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="text-right">{{ `${m.money} 백만원` }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="text-right">{{ `~${m.age}세` }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                PLAN 2
                <span class="text-caption">질병보장</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item class="px-0" style="min-height: 20px; border-bottom: 1px solid lightGrey">
                  <v-list-item-content><v-list-item-title class="text-center">보장</v-list-item-title></v-list-item-content>
                  <v-list-item-content><v-list-item-title class="text-center">보험 가입 유무</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-for="(m, i) in finance['재무-리스크'].value" :key="m.title" style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-title class="text-center">
                      <span class="font-weight-bold secondary--text">{{ m.text.split(/\s/g)[0] }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="text-center">{{ m.value ? '가입' : '미가입' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <p class="text-left font-italic" style="width: 100%; font-size: 10px; line-height: 14px">
            &#8251; 상기 산출 금액은 연금재원별 종신형 지급 방식으로 간략하게 산출하였습니다. 다양한 연금 재원 산출방법과 지급방법에 대해서는 별도로 전문가 또는 상품 가입 금융기관으로부터 상담을 통해
            확인해 보시기 바랍니다.
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-footer padless color="transparent">
      <div class="text-center pa-0" style="width: 100%">
        <span class="caption">&copy;삼성금융경력컨설팅센터</span>
      </div>
    </v-footer>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapMutations, mapState, mapGetters } from 'vuex'
import SummaryHeader from './SummaryHeader.vue'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/visualMap'
import echarts from 'echarts/lib/echarts'
export default {
  components: { SummaryHeader, 'v-chart': ECharts },
  name: 'Finance',
  created() {},
  mounted() {
    const expectedSalary = Number(this.finance['재무-기대근로소득'].value[0].value)
    this.drawChart(
      this.exit[16].map((k) => Number(k)),
      expectedSalary
    )
  },
  data() {
    return {
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
      opt: {
        // color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        grid: {
          show: false,
          containLabel: false,
          top: 40,
          bottom: 20,
          left: 60,
          width: 700,
        },
      },
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'exit']),
    // ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'life']),
    // ...mapGetters(['getExit', 'getFinanceGoalMoney', 'getWifeExit', 'hasWife', 'getChildrenCount', 'getParentsCount']),
    cellLength() {
      const seventyAt = this.me.birthAt + 71
      console.log(seventyAt, this.currentYear)
      return seventyAt - this.currentYear
    },
    crevasseAge() {
      const t = (this.exit[17] || []).slice(0)

      if (!t[0]) return '없음'
      else {
        const s = t.shift()
        const e = t.pop()

        if (!e) return '없음'
        else return s + '세부터 ' + e + '세까지'
      }
    },
    getInsurance() {
      const k = ((this.finance['재무-리스크'] || {}).value || []).filter((o) => !o.value)
      if (k.length === 0) return '없음'
      else return k.map((o) => o.text.split(/\s/g)[0]).join(',')
    },
    getSourcingMoney() {
      const t = _.orderBy(this.finance['재무-목적자금-우선순위'].list, ['order'], ['asc'])

      const e1 = t.shift().title
      const e2 = t.shift().title

      const k = this.finance['재무-목적자금-계획'].value

      const ep1 = Number(k.filter((o) => o.title === e1)[0].value[1]) + this.me.birthAt
      const ep2 = Number(k.filter((o) => o.title === e2)[0].value[1]) + this.me.birthAt

      return [
        [e1, ep1],
        [e2, ep2],
      ]
    },
  },
  methods: {
    getImg(event) {
      if (event === '정년') return '/images/retire.svg'
      if (event === '연금') return '/images/pension.svg'
      if (event === '결혼') return '/images/marry.svg'
      if (event === '상배') return '/images/solo.svg'
      if (event === '근속') return '/images/work.svg'
      if (event === '임피') return '/images/salary.svg'
      if (event === '취직') return '/images/job.svg'
      if (event === '가료') return '/images/care.svg'
    },
    drawChart(data, expectedSalary) {
      console.log('-->', data, expectedSalary)
      const boundary = []
      data.forEach((o, i) => {
        if (o < 0) boundary.push(i)
      })
      let p = [
        {
          gt: (boundary[0] || 0) < 0 ? 0 : boundary[0],
          lt: boundary.pop() || 0,
          // color: 'rgba(112, 202, 233, 0.9)',
          // color: '#6ac9ec',
          // color: '#F37C84',
        },
      ]
      if (boundary.length === 0) p = []
      const eventIdx = this.exit[0].indexOf('퇴직')

      const empLabel = `퇴직후 근로소득 (${expectedSalary}만원) 발생시`
      const option = {
        legend: {
          right: 0,
          top: 15,
          data: [{ name: '퇴직후 근로소득 미발생시' }, { name: empLabel }],
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [...new Array(this.cellLength).keys(), 1, 1].map((i) => {
            const yy = (i + this.currentYear).toString()
            return `'${yy.substr(2, 2)}`
          }),
        },
        yAxis: {
          position: 'left',
          type: 'value',
          name: '현금흐름[백만원]',
        },
        visualMap: {
          type: 'piecewise',
          show: false,
          dimension: 0,
          seriesIndex: 0,
          pieces: p,
        },
        series: [
          {
            name: '퇴직후 근로소득 미발생시',
            type: 'line',
            smooth: 0.2,
            symbol: 'none',
            lineStyle: {
              color: '#e65100',
              // color: 'red',
              // color: 'rgb(112, 202, 233)',
              width: 3,
            },
            markLine: {
              symbol: ['none', 'none'],
              label: { show: false },
              data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
            },
            areaStyle: {},
            data: data,
          },
          {
            name: empLabel,
            type: 'line',
            smooth: 0,
            symbol: 'none',
            lineStyle: {
              color: '#0e9cd8',
              // color: 'rgb(112, 202, 233)',
              width: 2,
            },
            // markLine: {
            //   symbol: ['none', 'none'],
            //   label: { show: false },
            //   data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
            // },
            data: data.map((k, i) => {
              if (i > eventIdx) return k + expectedSalary
              else return k
            }),
          },
        ],
      }
      console.log('-->', option)

      // opt.series[0].data = data
      // this.$refs.chart.setOption(option)
      this.$refs.chart.mergeOptions(option)
    },
    getExample() {
      // this.setExample()
    },
  },
}
</script>

<style lang="scss" scoped>
.summary-name {
  position: absolute;
  left: 40px;
  top: 200px;
}
.page {
  position: relative;
  border: 1px solid white;
  // width: 2480px;
  // height: 3508px;
  width: 21cm;
  height: 29.7cm;
  margin: auto;
  page-break-before: always;

  // @media print {
  //   body {
  //     width: 21cm;
  //     height: 29.7cm;
  //     margin: 30mm 45mm 30mm 45mm;
  //     /* change the margins as you want them to be. */
  //   }
  // }
  .contents {
    // border-top: 1px solid black;
    margin-top: 30px;
    height: 1090px - 30px;
    padding: 0 40px;

    .section-title {
      padding-top: 0px;
      font-weight: 900;
      font-size: 18px;
      height: 18px;
      color: #1c5eaa;
      font-family: 'SamsungSans';
    }
    .section-title-border {
      margin-left: 10px;
      flex-grow: 1;
      border-bottom: 1px solid #165caa;
    }
    .ans {
      // height: 30px;
      color: black;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.5em;
      max-height: 4.5em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .listing div.v-list-item__subtitle {
      font-size: 16px !important;
    }
    .listing div.v-list-item__title {
      font-size: 18px !important;
    }
    .listing div.v-list-item > div {
      line-height: 18px !important;
    }
    .bottom-border {
      border-bottom: 1px solid grey;
    }
    table.tbl {
      font-size: 10px;
      border-collapse: collapse !important;
      // table-layout: fixed;
      width: 710px;
      word-break: break-all;
      td {
        width: 30px !important;
        padding-right: 6px !important;
        position: relative;
        div {
          position: absolute;
          width: 100%;
          left: 0;
          top: 0;
          font-size: 10px;
        }
      }

      thead tr {
        font-weight: bold;
        font-size: 12px;
      }
      tr:nth-of-type(2n) {
        // background: #f7cac9;
      }
      tr.age-row > td {
        font-size: 12px !important;
        font-weight: 600;
        font-style: italic;
      }
      div.content-cell {
        line-height: 18px;
        background: #165caa;
        color: white;
        width: 30px;
        height: 16px;
        font-size: 11px !important;
        font-weight: 600;
        margin: auto;
        transform: translateY(-16px);
      }
      div.content-border {
        border-radius: 25px 25px 25px 25px;
      }

      div.pension-start {
        border-radius: 5px 45% 45% 5px;
      }
      td div.start-row {
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
      }
      td div.end-row {
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }
      tr.exit-row {
        height: 22px;
        font-size: 10px;
        font-weight: 600;

        td div {
          background: grey;
          color: white;
          width: 100%;
          height: 14px;
        }
        div.col-header {
          text-align: left;
          width: 90%;
          border-radius: 0 25px 25px 0;
          background: grey;
          color: white;
        }
      }
      th,
      td :not(.title-cell) {
        white-space: nowrap;
        word-break: break-all;
        // border: 1px solid grey;
      }
      td.title-cell {
        overflow-wrap: break-word;
      }
      th.event,
      td.event {
        background-color: rgba(196, 196, 196, 0.7); // background-color: rgba(42, 75, 124, 0.3) !important;
        div {
          background-color: rgba(196, 196, 196, 0.7);
          // background-color: rgba(42, 75, 124, 0.6) !important;
        }
      }
      .title-cell {
        min-width: 60px !important;
        // width: 4%;
        width: 70px;

        // background-color: #2a4b7c;
        // color: white;
      }
      td.minus {
        font-weight: 600;
        color: white;
        background-color: #e65100;
      }
    }
    .score {
      padding: 18px;
    }
    .life-top {
      font-size: 1em;
      border-bottom: 2px solid black;
    }
    .header-col {
      border-right: 1px solid black;
    }
    .life {
      text-align: center;
      min-height: 64px;
    }
    .life-footer {
    }
    // .echarts {
    //   width: 100%;
    //   height: 100%;
    // }
    .echarts {
      height: 240px;
      width: 100%;
    }
    .good {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .bad {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .happy-row {
      border-top: 1px solid grey;
    }
  }
  .footer {
    border-bottom: 1px solid grey;
    display: flex;
    align-items: flex-end;
    span {
      display: inline-block;
    }
  }
}
</style>
